import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { z } from "zod";
import { ensureElementVisible } from "@/lib/route-guards";

const LekiPrzeterminowanePage = lazy(() =>
	import("@/features/leki-przeterminowane/list-page").then((m) => ({
		default: m.LekiPrzeterminowanePage,
	})),
);

const day = z
	.string()
	.regex(/^\d{4}-\d{2}-\d{2}$/)
	.optional();

// Filtry w URL: kolejka KR i widok centrali wysyla sie linkiem.
const searchSchema = z.object({
	dataOd: day.catch(undefined),
	dataDo: day.catch(undefined),
	scope: z.string().optional(),
	status: z
		.enum(["czeka_kr", "czeka_dyr", "odrzucony", "zaakceptowany", "roznice", "anomalie"])
		.optional()
		.catch(undefined),
	columnFilters: z.string().optional(),
	sortBy: z.string().optional(),
	sortDir: z.enum(["asc", "desc"]).optional().catch(undefined),
	// Panel „Podsumowanie po spolkach” otwarty.
	podsumowanie: z.literal("1").optional().catch(undefined),
	// Dokument otwarty w panelu bocznym: `idfirm_iddokf_dataw` (`docParam` w api.ts).
	dok: z
		.string()
		.regex(/^\d+_\d+_\d{4}-\d{2}-\d{2}$/)
		.optional()
		.catch(undefined),
});

export const Route = createFileRoute("/_auth/dokumenty/leki-przeterminowane")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.dokumenty.leki-przeterminowane",
			location.pathname,
		);
	},
	component: LekiPrzeterminowanePage,
	validateSearch: (search: Record<string, unknown>) => searchSchema.parse(search),
});
